import { Component, Prop, Vue} from "vue-property-decorator";
import { RadioButtonInputModuleModel, RadioButtonInputModuleOption, ConfiguratorValueUpdateModel, configuratorConstants } from "../models";

@Component
export default class RadioButtonInputModule extends Vue {
    protected selectedOption: RadioButtonInputModuleOption<any> = {} as RadioButtonInputModuleOption<any>;

    @Prop()
    protected vm!: RadioButtonInputModuleModel<any>;

    protected created() {
        if (this.vm.options && this.vm.options.length) {
            const preselectedOption  = this.vm.options.find(x => x.preSelected);
            if (preselectedOption) {
                this.selectedOption = preselectedOption;
                this.onSelectedChange();
            }
        }
    }

    protected onSelectedChange(setCookie: boolean = false) {
        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.selectedOption.value,
             valueDescriptions: [{ title: "", text: this.selectedOption.description ? this.selectedOption.description : this.selectedOption.title }],
             propertyName: this.vm.configuratorProperties[0].propertyName, isText: false, resetClimateSavingsCookie: this.vm.resetClimateSavingsCookie };
        this.$emit("update-configurator-value", updateModel, setCookie);

        if (this.vm.configuratorProperties[0].propertyName === configuratorConstants.PlasterThicknessRange ||
            (this.vm.configuratorProperties[0].propertyName === configuratorConstants.PlasteredIndoorWallSides &&
                this.selectedOption.value === configuratorConstants.PlasteredIndoorWallSidesNone)) {
            const updateModelPlasterThickness: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: "",
                valueDescriptions: [{ title: "", text: "" }],
                propertyName: configuratorConstants.recommendedProductSelected, isText: false, resetClimateSavingsCookie: false };
            this.$emit("update-configurator-value", updateModelPlasterThickness, setCookie);
        }
    }
}
